import React from 'react';
import './App.css';
import Home from './Home';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Search from './Search';
import Material from './Material';
const App=() =>{
  return(
    <div>
  <BrowserRouter>
      <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/search/:value" element={<Search />}/>
      </Routes>
  </BrowserRouter>
  
    </div>
  )
}


export default App


